<template>
  <DetailLayoutFullWidth>
    <template slot="header">
      <div>
        <base-header-dashboard icon="user" :content="header" @onChangeClient="onChangeClient" :disableSelect="isLoading"/>
      </div>
    </template>
    <template slot="main">
      <div class="lg:mb-4 flex flex-col lg:flex-row border-2 divide-y-2 lg:divide-x-2 lg:divide-y-0 overflow-x-hidden dark:border-darkblue-600">
        <div class="px-2 w-full mb-2 lg:mb-0 overflow-hidden fix-loader-component dark:border-darkblue-600 vld-parent">
        <loading :opacity="darkMode ? 0 : 0.5" :active="isLoadingChart1 || isLoadingChart2" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
          <div v-if="showFacturasEmitidas">
            <div class="flex p-2 mt-2 justify-between md:justify-start">
              <div class="px-2 mb-2 lg:mb-0">
                <span class="font-bold link-name mr-4 truncate group-hover:text-primary dark:bg-darkblue-800 dark:text-darkblue-200">{{$t('invoices.issued_header')}}</span>
              </div>
              <div class="px-2 mb-2 lg:mb-0">
                <span class="dark:bg-darkblue-600 dark:text-darkblue-200 badge badge-warning right-0 z-20 badge-count active:bg-primary-200">
                  {{ $n(facturasEmitidasTotales, 'integer') }}
                </span>
              </div>
            </div>
            <Chart id="chart-one" 
              ref="issuedChart"
              type="horizontalBar" 
              :label="$t('invoices.chart_issued_header')" 
              :expand="showFacturasEmitidas && !showFacturasRecibidas"
              :charData="chartdataStatus1" 
              @callback="callbackHandler1" 
              @toogleLoadingTop="toogleLoadingTop1"/>
          </div>
          <div v-if="showFacturasRecibidas">
            <div class="flex p-2 mt-2 justify-between md:justify-start">
              <div class="px-2 mb-2 lg:mb-0">
                <span class="font-bold link-name mr-4 truncate group-hover:text-primary dark:bg-darkblue-800 dark:text-darkblue-200">{{$t('invoices.received_header')}}</span>
              </div>
              <div class="px-2 mb-2 lg:mb-0">
                <span class="dark:bg-darkblue-600 dark:text-darkblue-200 badge badge-warning right-0 z-20 badge-count active:bg-primary-200">
                  {{ $n(facturasRecibidasTotales, 'integer') }}
                </span>
              </div>
            </div>
            <Chart id="chart-two" 
              ref="receivedChart"
              type="horizontalBar" 
              :label="$t('invoices.chart_received_header')" 
              :expand="showFacturasRecibidas && !showFacturasEmitidas"
              :charData="chartdataStatus2" 
              @callback="callbackHandler2" 
              @toogleLoadingTop="toogleLoadingTop2"/>
          </div>
        </div>
        <div v-if="showLicenciamiento" class="flex-shrink-0 mb-2 lg:mb-0 lg:w-96 flex flex-col justify-around dark:border-darkblue-600">
          <div class="flex items-center justify-center" style="height: 32vh">
             <base-logo
              :filename="logo"
              alt="EdasInvoiZE"
              class="brand p-2 max-w-xs max-h-20"
            />
          </div>
          <hr class="dark:border-darkblue-600"/>
          <div 
            class="flex w-full items-center p-4 vld-parent">
            <loading :opacity="darkMode ? 0 : 0.5" :active="isLoadingFullStackData" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
            <div class="flex flex-col items-center w-full p-4">
              <div class="self-start">
                <h3 class="font-bold lpx-2 w-full mb-2 lg:mb-0 group-hover:text-primary dark:text-darkblue-200">
                  {{$t('license.header')}}
                </h3>
              </div>
              <ChartHFullStack 
                id="chart-fullstack" 
                ref="licenseChart"
                type="horizontalBar" 
                :label="$t('license.header')" 
                :chardataFullstack="chardataFullstack"
                class="justify-self-center"
                />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions"> </template>
      </base-footer>
    </template>
  </DetailLayoutFullWidth>
</template>

<script>
import { i18n } from '@/i18n'
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import Chart from '@/components/charts/Chart.vue'
import ChartHFullStack from '@/components/charts/ChartHFullStack.vue'

import Loading from 'vue-loading-overlay'

import { getDashoardFullStack } from '@/services/dashboard/getDashoardFullStack' 
import { getEstadoFacturas } from '@/services/dashboard/getEstadoFacturas'


export default {
  name: 'dashboard-detail',
  components: {
    DetailLayoutFullWidth,
    Loading,
    Chart,
    ChartHFullStack,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('app.dashboard'),
        icon: 'docblack',
        breadcrumb: null,
        url: null
      },
      isLoadingChart1: false,
      isLoadingChart2: false,
      isLoadingFullStackData: false,
      // Almacenamiento cliente
      chartdataStatus1: [],
      chartdataStatus2: [],
      chardataFullstack: [],
      facturasEmitidasTotales: 0,
      facturasRecibidasTotales: 0,

      modeDisableLongQueries: process.env.VUE_APP_DISABLE_LONG_QUERIES,
    }
  },
  watch: {
    $route: 'routerChangeHandler'
  },
  mounted: async function () {
    this.routerChangeHandler()
  },
  computed: {
    isRoleProvider: function () {
      return this.role === 9
    },
    showFacturasEmitidas () {
      return this.facturasEmitidasTotales > 0 || (this.facturasEmitidasTotales === 0 && this.facturasRecibidasTotales === 0)
    },
    showFacturasRecibidas () {
      return this.facturasRecibidasTotales > 0 || (this.facturasEmitidasTotales === 0 && this.facturasRecibidasTotales === 0)
    },
    logo: function () {
      if (this.darkMode) {
        return 'logo-edasinvoize-dark.webp'
      }
      return 'logo-edasinvoize.webp'
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    selectedClientDashboard () {
      return this.$store.getters['dashboard/getSelectedClient']
    },
    isSelectedClientDashboard () {
      return this.selectedClientDashboard !== undefined && this.selectedClientDashboard !== null && this.selectedClientDashboard !== 0
    },
    isSelectedClientEmpty () {
      return this.selectedClientDashboard !== undefined && this.selectedClientDashboard !== null && this.selectedClientDashboard === -1
    },
    showLicenciamiento () {
      if (this.role === 3 || this.role === 8 || this.role === 7) {
        if (this.isSelectedClientEmpty) {
          return false
        }
        if (!this.isSelectedClientDashboard && !this.isSelectedClientEmpty) {
          return false
        }
      }
      if (this.isRoleProvider) {
        return false
      }
      return true
    },
    selectedClientNameDashboard () {
      return this.$store.getters['dashboard/getSelectedClientName']
    },
    isLoading () {
      return this.isLoadingChart1 || this.isLoadingChart2 || this.isLoadingFullStackData
    },
    tiposEstado: function () {
      return this.$store.getters['config/TIPOS_ESTADO']
    },
    tiposEstadoRecibidas: function () {
      return this.$store.getters['config/TIPOS_ESTADO_RECEPCION']
    },
    tiposLicenciamientoDashboard: function () {
      return this.$store.getters['config/DASHBOARD_LICENCIAMIENTO']
    },
  },
  methods: {
    onChangeClient () {
      this.routerChangeHandler()
    },
    toogleLoadingTop1 (value) {
      this.isLoadingChart1 = value
    },
    toogleLoadingTop2 (value) {
      this.isLoadingChart2 = value
    },
    getParamIdClient () {
      const idClient = this.$store.getters['dashboard/getSelectedClient']
      if ((this.role === 7 || this.role === 8 || this.role === 3) && idClient) { 
        return { idCliente: this.$store.getters['dashboard/getSelectedClient'] } 
      }
      return null
    },
    routerChangeHandler: async function () {
      const paramIdClient = this.getParamIdClient()

      this.isLoadingChart1 = true
      this.isLoadingChart2 = true
      this.isLoadingFullStackData = true
    
      this.loadChartAsync(paramIdClient)
      this.loadFullStackInfo(paramIdClient)

      this.facturasEmitidasTotales = 0
      this.facturasRecibidasTotales = 0
    },
    loadChartAsync: async function (paramIdClient) {
      // Chart Top left
      try {
        // if (this.role !== 7) {
        const estadoFacturas = await getEstadoFacturas(paramIdClient)
        if (estadoFacturas.blnError === false) {
          const data = estadoFacturas
          this.chartdataStatus1 = []
          const chartDataStatus1 = []
          data.Emitidas.Respuesta.forEach((element) => {
            const Descripcion = this.tiposEstado.find(x => x.id === element.Estado.idEstado)?.Nombre ?? element.Estado.Descripcion
            const obj = { label: Descripcion, value: element.Numero, Estado: { idEstado: element.Estado.idEstado, Descripcion: element.Estado.Descripcion } }
            chartDataStatus1.push(obj)
            this.facturasEmitidasTotales += element.Numero
          })
  
          this.chartdataStatus2 = []
          const chartdataStatus2 = []
          data.Recibidas.Respuesta.forEach((element) => {
            const Descripcion = this.tiposEstadoRecibidas.find(x => x.id === element.Estado.idEstado)?.Nombre ?? element.Estado.Descripcion
            const obj = { label: Descripcion, value: element.Numero, Estado: { idEstado: element.Estado.idEstado, Descripcion: element.Estado.Descripcion } }
            chartdataStatus2.push(obj)
            this.facturasRecibidasTotales += element.Numero
          })
  
          // Esperamos para setear por posibilidad de carga mal del chart mientras se reajusta el dom
          setTimeout(() => {
            this.chartdataStatus1 = chartDataStatus1
            this.chartdataStatus2 = chartdataStatus2
          }, 100)
        } else {
          this.doFeedback(`${estadoFacturas.msgError} [${estadoFacturas.codError}]`)
        }
        // }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadingChart1 = false
        this.isLoadingChart2 = false
      }
    },
    loadFullStackInfo: async function (paramIdClient) {
      // Top right 1 (Almacenamiento cliente)
      try {
        if (!this.showLicenciamiento) return
        this.isLoadingFullStackData = true
        const dataFullStack = await getDashoardFullStack(paramIdClient)
        if (dataFullStack.blnError === false) {
          this.chardataFullstack = []
          dataFullStack.Lista.forEach(x => {
            const name = this.tiposLicenciamientoDashboard.find(tipo => tipo.id === x.Nombre)?.name ?? x.Nombre
            this.chardataFullstack.push({
              nombre: name,
              porcentajeEnUso: x.Porcentaje,
              porcentajeRestante: 100 - x.Porcentaje,
              numUtilizado: x.Utilizado,
              numTotal: x.Total,
            })
          })
        } else {
          this.doFeedback(`${dataFullStack.msgError} [${dataFullStack.codError}]`)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadingFullStackData = false  
      }
    },
    callbackHandler1: function (data) {
      if (this.role === 7) return
      const invoices = this.$store.getters['app/tiposAccionesFacturasGroups']
      let id = 99999
      invoices.FacturasEmitidas.forEach(sc => {
        sc.Estados.forEach(es => {
          if (data === es.Descripcion) {
            id = es.idEstado
          }
        })
      })

      if (this.isSelectedClientDashboard && !this.isSelectedClientEmpty) {       
        const payloadFilter = this.getPayloadClientFilter()
        this.$store.commit('invoicesIssued/setMasterFilters', payloadFilter)

        if (id === 99999) this.$router.push({ name: 'invoicesissued' })
        else this.$router.push({ name: 'invoicesissued', hash: '/'+id })
      } else {
        this.$router.push({ path: id === 99999 ? '/'+process.env.VUE_APP_ROUTE_BASE+'/invoicesissued' : '/'+process.env.VUE_APP_ROUTE_BASE+'/invoicesissued/' + id })
      }
    },
    callbackHandler2: function (data) {
      if (this.role === 7) return
      const invoices = this.$store.getters['app/tiposAccionesFacturasGroups']
      let id = 99999
      invoices.FacturasRecibidas.forEach(sc => {
        sc.Estados.forEach(es => {
          if (data === es.Descripcion) {
            id = es.idEstado
          }
        })
      })

      if (this.isSelectedClientDashboard && !this.isSelectedClientEmpty) {
        const payloadFilter = this.getPayloadClientFilter()
        this.$store.commit('invoicesReceived/setMasterFilters', payloadFilter)

        // dataFilters.filters.push({ type: 'cliente', data: { label: this.selectedClientNameDashboard, id: this.selectedClientDashboard } })
        if (id === 99999) this.$router.push({ name: 'invoicesreceived' })
        else this.$router.push({ name: 'invoicesreceived', hash: '/'+id })
      } else {
        this.$router.push({ path: id === 99999 ? '/'+process.env.VUE_APP_ROUTE_BASE+'/invoicesreceived' : '/'+process.env.VUE_APP_ROUTE_BASE+'/invoicesreceived/' + id })
      }
    },
    getPayloadClientFilter () {
      return {
        empresa: {
          label: i18n.t('clients.entity_name'),
          value: {
            Nombre: this.selectedClientNameDashboard,
            idCliente: this.selectedClientDashboard,
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" >
.badge-count {
  font-size: 16px;
  @apply bg-primary-100;
  color: rgb(87, 84, 84);
  padding: 5px 10px;
  vertical-align: center;
  margin-top: -15px;
}

.badge {
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}

.label-warning[href],
.badge-warning[href] {
  background-color: #c67605;
}

.fix-loader-component{
  border-left:none;
  border-top:none;
}
</style>
